module.exports = __webpack_public_path__ + "img/engine.8775e005.svg";